import $ from 'jquery';

export default class Header {
    constructor() {
        

        this.bind();
    }

    bind() {
        // this.$hamburger.on("click", this.toggleMenu.bind(this));
    }

    // toggleMenu() {
        
    // }
}